import * as React from 'react';
import * as UserActions from '../../actions/users';
import { UserData } from '../../models/User';
import * as request from 'superagent';
import { toast } from 'react-toastify';

import Background from '../Common/Background';

export declare interface SchoolRecord {
	_id: string;
	name: string;
}

export namespace Register {
	export interface Props {
		userActions: typeof UserActions;
		toggleRegistration: (e: any)=>void;
	}

	export interface State {
		schools: Array<SchoolRecord>;
	}
}

export default class Register extends React.Component<Register.Props, Register.State> {

	username: HTMLInputElement;
	password: HTMLInputElement;
	password2: HTMLInputElement;
	firstname: HTMLInputElement;
	lastname: HTMLInputElement;
	school: HTMLSelectElement;
	code: HTMLInputElement;

	constructor(props: Register.Props) {
		super(props);
		this.registerUser = this.registerUser.bind(this);

		this.state = { schools: [] };

		request
			.get('/client/schools')
			.end((err, res) => {
				if (err) {
					console.log(res.text);
				} else {
					this.setState({schools: res.body})
				}
			});
	}

	registerUser(e: any) {
		e.preventDefault();

		if (this.password.value !== this.password2.value) {
			toast.error('Salasanat eivät täsmää');
			return;
		}

		const { userActions } = this.props;
		const userData: UserData = {
			_id: null,
			firstname: this.firstname.value,
			lastname: this.lastname.value,
			username: this.username.value,
			password: this.password.value,
			school: this.school.value,
			client: this.school.value
		};
		userActions.registerUser({user: userData, code: this.code.value});
	}

	render() {
		const { schools } = this.state;

		let schoolDOMs = [];
		for (let i = 0; i < schools.length; i++) {
			schoolDOMs.push(<option value={schools[i]._id}>{schools[i].name}</option>);
		}

		return (
			<div className="registerPort">
				<Background src="/images/ControlBackground.png" width={1500} height={1052} />
				<div className="regCentralizer"></div>
				<div className="registerMargins">
					<div className="am_regLogoContainer">
						<img className="am_req_mainLogo" src="/images/Arviointimaa-logo.png" />
					</div>
					<h6 className="am_title text-center">Opettajan hallintapaneeli</h6>
					<div className="jumbotron am_teacher_reg_container col-6 offset-3 am_shadow">
						<div>
							<form className="form-group" id="am_register" onSubmit={this.registerUser}>
								<p style={{ fontSize: "12px", textAlign: "center", color:"darkblue", marginBottom: "0.75rem"}}><b>Tervetuloa Arviointimaan käyttäjäksi!<br></br>Valitse pudotuspalkista koulusi:</b></p>
								<select ref={(input) => this.school = input} className="registerInput col-12 form-control mb-3">
										{schoolDOMs}
								</select>
								<p style={{ fontSize: "11px", textAlign: "center", color:"darkblue", marginBottom: "0.75rem"}}><b>Syötä koulusi sinulle antama käyttäjäkoodi:</b></p>
								<input ref={(input) => this.code = input} className="registerInput col-12 form-control" placeholder="Koodi" required/>
								<p style={{ fontSize: "11px", textAlign: "center", color:"darkblue", marginTop: "18px", marginBottom: "0.75rem"}}><b>Syötä tunnistautumistietosi:</b></p>
								<div className="fullnameInputs">
									<input ref={(input) => this.firstname = input} className="registerInput fullnameInput col-12 form-control" placeholder="Etunimi" required/>
									<input ref={(input) => this.lastname = input} className="registerInput fullnameInput col-12 form-control" placeholder="Sukunimi" required/>
								</div>
								<input ref={(input) => this.username = input} className="registerInput col-12 form-control" placeholder="Käyttäjänimi" required/>
								<input ref={(input) => this.password = input} className="registerInput noBottomMargin col-12 form-control" placeholder="Salasana" type="password" required/>
								<input ref={(input) => this.password2 = input} className="registerInput col-12 form-control" placeholder="Salasana uudelleen" type="password" required/>
								<button type="submit" style={{display: "flex"}} className="col-12 btn form-control am_green-button am_shadow">
									<img style={{height: "40px"}} src="images/GreenConfirmButton.png" className="am_smallicon" />
									<p style={{margin: "auto 0", width: "calc(100% - 2rem - 38px)"}}>LUO TUNNUS JA KIRJAUDU</p>
								</button>
							</form>			
						</div>
					</div>
				</div>
				<div className="regCentralizer"></div>
			</div>
		);
	}
}


// WEBPACK FOOTER //
// ./~/tslint-loader!./react/narrapix/src/containers/LoginTeacher/register.tsx